import { Flex } from "antd";
import { useTranslation } from "react-i18next";
import type RateModel from "../../viewModels/Rate/RateModel";
import DangerCargoIcon from "../../icons/DangerCargoIcon.svg?react";
import OversizeCargoIcon from "../../icons/OversizeCargoIcon.svg?react";
import SanctionCargoIcon from "../../icons/SanctionCargoIcon.svg?react";
import TemperatureRegimeIcon from "../../icons/TemperatureRegimeIcon.svg?react";

type Props = {
  rate: Pick<RateModel, "isDangerous" | "isOversized" | "isRefrigeratorRequired" | "isSanctionsCargo">;
};

export default function RateCargoIcons({ rate }: Props) {
  const { t } = useTranslation("translations");
  return (
    <Flex align="center" gap={4}>
      {rate.isDangerous && <DangerCargoIcon role="img" aria-label={t("danger_cargo")} />}
      {rate.isOversized && <OversizeCargoIcon role="img" aria-label={t("oversized_cargo")} />}
      {rate.isRefrigeratorRequired && <TemperatureRegimeIcon role="img" aria-label={t("temperature_regime")} />}
      {rate.isSanctionsCargo && <SanctionCargoIcon role="img" aria-label={t("sanctioned_cargo")} />}
    </Flex>
  );
}
